import { render, staticRenderFns } from "./Genel.vue?vue&type=template&id=5e908f88&scoped=true"
import script from "./Genel.vue?vue&type=script&lang=js"
export * from "./Genel.vue?vue&type=script&lang=js"
import style0 from "./Genel.vue?vue&type=style&index=0&id=5e908f88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e908f88",
  null
  
)

export default component.exports